import { useEffect, useRef } from "react";

declare global {
  interface Window {
    tiktok?: {
      parse: () => void;
    };
  }
}

interface TikTokEmbedProps {
  url: string;
  width?: number | string;
}

export default function ArticleEmbedTikTok({
  url,
  width = 325,
}: TikTokEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (
      !document.querySelector('script[src="https://www.tiktok.com/embed.js"]')
    ) {
      const script = document.createElement("script");
      script.src = "https://www.tiktok.com/embed.js";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (window.tiktok?.parse) {
          window.tiktok.parse();
        }
      };
    } else {
      if (window.tiktok?.parse) {
        window.tiktok.parse();
      }
    }
  }, [url]);

  const videoId = url.split("/").filter(Boolean).pop() ?? "";

  return (
    <div ref={containerRef} style={{ maxWidth: width, margin: "0 auto" }}>
      <blockquote
        className="tiktok-embed"
        cite={url}
        data-video-id={videoId}
        style={{ maxWidth: width, minWidth: 325 }}
        data-embed-from="oembed"
      >
        <section>Loading TikTok video...</section>
      </blockquote>
    </div>
  );
}
